import { withNamespace } from "@/i18n/lazy-route"

/** Jobs, the system's status and the audit log (LLD §9.24, Task 6.6), with the `adminOps` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminOps.json"),
  fr: () => import("@/i18n/locales/fr/adminOps.json"),
}

export const JobsScreen = withNamespace(
  "adminOps",
  () => import("./screens/JobsScreen"),
  translations,
)
export const JobScreen = withNamespace(
  "adminOps",
  () => import("./screens/JobScreen"),
  translations,
)
export const StatusScreen = withNamespace(
  "adminOps",
  () => import("./screens/StatusScreen"),
  translations,
)
export const AuditScreen = withNamespace(
  "adminOps",
  () => import("./screens/AuditScreen"),
  translations,
)
